// extracted by mini-css-extract-plugin
export default {"contextMenuWrapper":"ContextMenu_contextMenuWrapper__uu1CR","addData":"ContextMenu_addData__Pk2pa","popup":"ContextMenu_popup__8rKQ9","contract":"ContextMenu_contract__2zC5N"};